// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/
.HeaderModal-logInModalContainer-I5K_a {
	max-width: 1140px;
	margin: 54px auto;
	width: 100%;
	padding: 10px;
}
.HeaderModal-modalHeader-tKaUk {
	font-size: 26px;
	margin-top: 24px;
	font-weight: 700;
	text-align: center;
	margin-bottom: 0px;
}
.HeaderModal-languageAndCurrencyModal-SxOmZ {
	margin: 30px;
	padding: 0;
}
@media screen and (max-width: 767px) {
	.HeaderModal-modalHeader-tKaUk {
		margin-top: 55px;
	}

	.HeaderModal-logInModalContainer-I5K_a {
		margin: 0px auto;
	}

	.HeaderModal-languageAndCurrencyModal-SxOmZ {
		margin: 20px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/HeaderModal/HeaderModal.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;CACC,iBAAiB;CACjB,iBAAiB;CACjB,WAAW;CACX,aAAa;AACd;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;AAEA;CACC,YAAY;CACZ,UAAU;AACX;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,YAAY;CACb;AACD","sourcesContent":["/** RentAll - Begin **/\n.logInModalContainer {\n\tmax-width: 1140px;\n\tmargin: 54px auto;\n\twidth: 100%;\n\tpadding: 10px;\n}\n\n.modalHeader {\n\tfont-size: 26px;\n\tmargin-top: 24px;\n\tfont-weight: 700;\n\ttext-align: center;\n\tmargin-bottom: 0px;\n}\n\n.languageAndCurrencyModal {\n\tmargin: 30px;\n\tpadding: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.modalHeader {\n\t\tmargin-top: 55px;\n\t}\n\n\t.logInModalContainer {\n\t\tmargin: 0px auto;\n\t}\n\n\t.languageAndCurrencyModal {\n\t\tmargin: 20px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logInModalContainer": `HeaderModal-logInModalContainer-I5K_a`,
	"modalHeader": `HeaderModal-modalHeader-tKaUk`,
	"languageAndCurrencyModal": `HeaderModal-languageAndCurrencyModal-SxOmZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
